<template>
    <footer class="secured" v-show="state.currency !== 'KES'">
        <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.091 3.887h-.55v-.845C7.54 1.364 6.097 0 4.358 0 2.621 0 1.18 1.364 1.18 3.042v.845h-.51c-.282 0-.48.341-.48.614v5.143c0 .272.198.381.48.381h7.437c.282 0 .438-.109.438-.381V4.5c-.014-.273-.184-.614-.453-.614Zm-4.41 4.365.226-1.255a.706.706 0 0 1-.325-.586c0-.423.354-.764.792-.764.438 0 .791.341.791.764 0 .259-.127.436-.325.573l.226 1.268H3.681Zm-1.654-5.21v.845h4.665v-.845C6.692 1.8 5.632.805 4.36.805c-1.273 0-2.333 1.01-2.333 2.237Z" fill="#FF9B00"/></svg>
        <label class="secured__text"> {{ translate("ui.secured.text", "SECURED BY FLUTTERWAVE") }} </label>
    </footer>
</template>

<script>
import { mapState } from "redux-vuex";
import { getValueFromPath } from "@/support/helpers";

export default {
    name: "SecuredByFlutterwave",
    setup() {
        return {
            state: mapState({
                currency: (state) => getValueFromPath(state, "currency.current") || null,
            }),
        };
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.secured {
  display: none;
  justify-content: center;
  @include screen(menner) {
    display: flex;
    align-items: center;
    max-width: 20rem;
    margin: 5rem auto;
    padding: .7rem 1.1rem .8rem 1.1rem;
    border: 1.24324px solid $gray-1;
    box-sizing: border-box;
    border-radius: 3.13297px;
  }
  svg {
    margin-right: .84rem;
  }
  &__text {
    font-size: 1rem;
    line-height: 1.4rem;
    font-weight: $font-bold;
    letter-spacing: 0.3px;
    color: #703E00;
  }
}
</style>